export const modalType = {
    menu: 'menu',
    create: 'create',
    update: 'update',
}

export const TargetModalDataEnum = {
    CATEGORY: 'CATEGORY', // 새 메뉴/카테고리 모달 띄울 때 분류
    MENU: 'MENU',
    INIT: '', // 최초 실행 시에는 빈값
}